export const PREFERENCE_KEYS = {
  IDENTIFIER: 'userPreference.identifierDisplay',
} as const
